module.exports = "/assets/data/e39d3489a09964586a89820660bb94fe-FK7.data.json";